import store from 'store/store';
import { updateUserData, updateUserCore, setAuthSuccess } from 'store/modules/users/authReducer';
import { getUserPortfolio, updateLoadedPortfolio } from 'store/modules/profile/profileReducer';
import { getUserProfile } from 'services/users';
import React from 'react';
import api from 'services/api';

export const updateUserAccount = async () => {
  return getUserProfile().then((res) => {
    if (res && res.data) {
      store.dispatch(getUserPortfolio(res.data));
      store.dispatch(updateLoadedPortfolio({ loadedPortfolio: true }));
      store.dispatch(updateUserData({ user: res.data.data }));
      store.dispatch(updateUserCore({ userCore: res.data }));

      return res;
    }
  });
};

export const getUserIfToken = async () => {
  const { token } = api;

  if (token) {
    return getUserProfile().then((res) => {
      if (res && res.data) {
        store.dispatch(setAuthSuccess({ user: res.data.data, token }));
        return res;
      }
    });
  }
};

// export const updateUserToken = () => {
//     let user = store.getState().authReducer.user;
//     updateUserProfile({}).then((res) => {
//         console.log(res);
//     })
// }

export const trimPassword = (val: React.ChangeEvent<HTMLInputElement>) => {
  const trimmedValue = val?.target?.value?.replace(/\s/g, '');
  val.target.value = trimmedValue;
  return val;
};
